/**************************************************
 * Nombre:       Formulario_Certificado
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, BadgeOutlined, Flag, Title} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOANUNCIOS} from "../../Constantes";
import IngresoImagen from "../../Modulo_formularios/Componentes/IngresoImagen";

const Formulario_Certificado = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagen dato={'img'} {...props} ancho={2} alto={2}/>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOANUNCIOS.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Title} nombre={'Nombre'} dato={'nombre'} {...props}

                    />
                </Grid>



            </Grid>

        </form>

    )

}
export default Formulario_Certificado